// extracted by mini-css-extract-plugin
export default {"root":"xNxJ2c1h4htAiKHQZ_aR","header":"ZbcNO4Ynus6aBPbTOwyW","list":"n1QOMjSnPDp6oqB3K4s7","placeHolderShimmer":"bBo5T8rskMto6xjXsarm"};